import * as React from 'react';
import { KnowledgeArticle } from "../../dto/KnowledgeArticle";
import * as WhatIsIanus from "./WhatIsIanus";
import * as HowDoesItWork from "./HowDoesItWork";
import * as GettingStarted from "./GettingStarted";
import * as HowToCanavs from "./HowToCanvas";
import * as HowToFlow from "./HowToFlow";
import * as HowToMDA from "./HowToMDA";
import * as HowToPCF from "./HowToPCF";
import * as HowToPlugin from "./HowToPlugin";
import * as Pricing from "./Pricing";
import * as Trust from "./Trust";
import * as DoesIanusLimitOffline from "./DoesIanusLimitOffline";
import * as HowToImportLicense from "./HowToImportLicense";
import * as CustomerPrivacy from "./CustomerPrivacy";
import * as Shipping from "./Shipping";

export type ArticleType = "general" | "publisher" | "customer";

export const articles: Record<ArticleType, Array<KnowledgeArticle>> = {
    "general": [
        {
            id: WhatIsIanus.Id,
            title: WhatIsIanus.Title,
            subtitle: WhatIsIanus.Subtitle,
            description: WhatIsIanus.Description,
            keywords: WhatIsIanus.Keywords,
            component: <WhatIsIanus.Component />
        },
        {
            id: HowDoesItWork.Id,
            title: HowDoesItWork.Title,
            subtitle: HowDoesItWork.Subtitle,
            description: HowDoesItWork.Description,
            keywords: HowDoesItWork.Keywords,
            component: <HowDoesItWork.Component />
        },
        {
            id: GettingStarted.Id,
            title: GettingStarted.Title,
            subtitle: GettingStarted.Subtitle,
            description: GettingStarted.Description,
            keywords: GettingStarted.Keywords,
            component: <GettingStarted.Component />
        },
        {
            id: Pricing.Id,
            title: Pricing.Title,
            subtitle: Pricing.Subtitle,
            description: Pricing.Description,
            keywords: Pricing.Keywords,
            component: <Pricing.Component />
        },
        {
            id: Trust.Id,
            title: Trust.Title,
            subtitle: Trust.Subtitle,
            description: Trust.Description,
            keywords: Trust.Keywords,
            component: <Trust.Component />
        }
    ],
    "publisher": [
        {
            id: HowToPCF.Id,
            title: HowToPCF.Title,
            subtitle: HowToPCF.Subtitle,
            description: HowToPCF.Description,
            keywords: HowToPCF.Keywords,
            component: <HowToPCF.Component />
        },
        {
            id: HowToPlugin.Id,
            title: HowToPlugin.Title,
            subtitle: HowToPlugin.Subtitle,
            description: HowToPlugin.Description,
            keywords: HowToPlugin.Keywords,
            component: <HowToPlugin.Component />
        },
        {
            id: HowToFlow.Id,
            title: HowToFlow.Title,
            subtitle: HowToFlow.Subtitle,
            description: HowToFlow.Description,
            keywords: HowToFlow.Keywords,
            component: <HowToFlow.Component />
        },
        {
            id: HowToCanavs.Id,
            title: HowToCanavs.Title,
            subtitle: HowToCanavs.Subtitle,
            description: HowToCanavs.Description,
            keywords: HowToCanavs.Keywords,
            component: <HowToCanavs.Component />
        },
        {
            id: HowToMDA.Id,
            title: HowToMDA.Title,
            subtitle: HowToMDA.Subtitle,
            description: HowToMDA.Description,
            keywords: HowToMDA.Keywords,
            component: <HowToMDA.Component />
        },
        {
            id: Shipping.Id,
            title: Shipping.Title,
            subtitle: Shipping.Subtitle,
            description: Shipping.Description,
            keywords: Shipping.Keywords,
            component: <Shipping.Component />
        },
        {
            id: Pricing.Id,
            title: Pricing.Title,
            subtitle: Pricing.Subtitle,
            description: Pricing.Description,
            keywords: Pricing.Keywords,
            component: <Pricing.Component />
        },
        {
            id: Trust.Id,
            title: Trust.Title,
            subtitle: Trust.Subtitle,
            description: Trust.Description,
            keywords: Trust.Keywords,
            component: <Trust.Component />
        }
    ],
    "customer": [
        {
            id: DoesIanusLimitOffline.Id,
            title: DoesIanusLimitOffline.Title,
            subtitle: DoesIanusLimitOffline.Subtitle,
            description: DoesIanusLimitOffline.Description,
            keywords: DoesIanusLimitOffline.Keywords,
            component: <DoesIanusLimitOffline.Component />
        },
        {
            id: HowToImportLicense.Id,
            title: HowToImportLicense.Title,
            subtitle: HowToImportLicense.Subtitle,
            description: HowToImportLicense.Description,
            keywords: HowToImportLicense.Keywords,
            component: <HowToImportLicense.Component />
        },
        {
            id: CustomerPrivacy.Id,
            title: CustomerPrivacy.Title,
            subtitle: CustomerPrivacy.Subtitle,
            description: CustomerPrivacy.Description,
            keywords: CustomerPrivacy.Keywords,
            component: <CustomerPrivacy.Component />
        }
    ]
};